module.exports = __webpack_public_path__ + "img/SES_194258400.ea4252c0.jpg";